import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchInspectionReportData } from "../car-details/actions";
import QualityPromiseRevamp from "./component";

const mapStateToProps = ({
    carDetails: {
        content,
        inspectionReportData,
        config
    },
    checkout: {
        extendedWarranty: {
            warrantyPlanInfo
        }
    }
}) => ({
    content,
    inspectionReportData,
    config,
    warrantyPlanInfo
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchInspectionReportDataConnect: fetchInspectionReportData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(QualityPromiseRevamp);
